import { render } from "./PlantJournalForPlant.vue?vue&type=template&id=a970ed38"
import script from "./PlantJournalForPlant.vue?vue&type=script&lang=js"
export * from "./PlantJournalForPlant.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__